import TextCreate from 'core/display/simple/Text'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class BalanceText extends TextCreate{
  constructor(data) {
    super(data)
    if(data.hide) {
      this.visible = false
    }
    this.started = false
    this.winModel = game.models.WinModel.get()
    this.spinModel = game.models.SpinModel.get()

    this.balance = { value: 0 }

    signal.once('INIT:REGULAR', this.start.bind(this))
    signal.once('INIT:FREESPINS', this.start.bind(this))
    signal.once('STATE:IN:FS-START', this.start.bind(this))
    signal.once('STATE:OUT:FS-END', this.start.bind(this))
    signal.on('BALANCE:UPDATE', this.updateTweenBalance.bind(this))
    signal.on('BALANCE:SERVER:UPDATE', this.balanceServerUpdate.bind(this))
  }

  start() {
    if (!this.started) {
      this.update()
      signal.on('ACTION:REQUEST-SPIN', this.spin.bind(this))
      signal.on('WIN-COLLECT', this.win.bind(this))
      signal.on('CASCADE-WIN-UPDATE-COUNTER', this.cascadeWin.bind(this))
      signal.on('STATE:OUT:RESPIN', this.joinRespin.bind(this))
      this.started = true
    }
  }

  joinRespin() {
    !this.winModel.winLines.length && this.roll(game.models.BalanceModel.get(), time.respin)
  }

  update() {
    this.balance.value = game.models.BalanceModel.get()
    this.onUpdate()
  }

  balanceServerUpdate(){
    if (this.balance.value !== game.models.BalanceModel.get()) {
      this.roll(game.models.BalanceModel.get(), 1)
    }
  }

  updateTweenBalance(){
    this.roll(game.models.BalanceModel.get(), time.spin)
  }

  spin() {
    const current = game.models.SpinModel.get().action
    if(game.models.ModeModel.buyFeature) {
      const multiplier = game.models.SpinModel.get().buy[0]
      this.roll(game.models.BalanceModel.get() - (game.models.BetModel.getValue() * multiplier), time.spin)
      signal.dispatch('BALANCE:SERVER:UPDATE')
    }
    else {
      if(current === 'freebet' || current === 'respin' || current !== 'spin') {
        return
      }
      this.roll(game.models.BalanceModel.get() - game.models.BetModel.getValue(), time.spin)
      signal.dispatch('BALANCE:SERVER:UPDATE')
    }
  }

  cascadeWin({ type, amount }){
    const value = Math.min(this.balance.value + amount, game.models.BalanceModel.get())

    this.roll(value, time[type])
  }

  win({ type, amount }) {
    const value = !this.spinModel.respinTotalWin ? Math.min(this.balance.value + amount, game.models.BalanceModel.get()) : game.models.BalanceModel.get()
    this.rollWin(value, time[type])
  }

  roll(value, time) {
    const balanceTween =  gsap.to(this.balance, time, {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        balanceTween.kill()
      },
    })
  }
  rollWin(value, time) {
    const balanceTween =  gsap.to(this.balance, time, {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        balanceTween.kill()
        if (!game.models.WinModel.get().expendingWin){
          signal.dispatch('BALANCE:SERVER:UPDATE')
        }
      },
    })
  }

  onUpdate() {
    super.update(FormatService.currency(this.balance.value))
  }
}
